module.exports = __webpack_public_path__ + "static/newbabymain-0d2a9842794e8a1681ebde0059b4ec80.png";